import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ipe57bk2: FaireBrandEntity = {
  token: "b_ipe57bk2",
  type: "brand",
  name: "Margolis Pineo Italia",
  avatarUrl:
    "https://cdn.faire.com/fastly/0f3db03291dd748e43c27a262b971ffbe8581cff4db1513ed1749ff1ed831631.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/bc681bbfede437cd4e66a5c6df06b248090dcb02f9bc338f62fc675dfdd7d643.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/0f3db03291dd748e43c27a262b971ffbe8581cff4db1513ed1749ff1ed831631.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/bc681bbfede437cd4e66a5c6df06b248090dcb02f9bc338f62fc675dfdd7d643.jpeg",
  location: "Portland, ME, USA",
  minimumOrderDollars: 199,
  rating: 5,
  reviewCount: 26,
  isTopShop: true,
  isInsider: true,
  description:
    'Our Travel Scarf and Wrap Collection offers ponchos, shawls and scarves in relaxed and elegant Italian style. We developed our line of Italian knitwear 20+ years ago and now enjoy a devoted following of wholesale and retail partners, clamoring for our unfussy signature pieces in beautiful Italian hues. Our timeless cashmere blends are perfect with jeans or little back dress — they don\'t cling or pill — and add a layer of warmth and softness that works as hard as you do. Our "Cozy At Home" cashmere collection is an everyday indulgence. Our recycled cashmere collection and eco-blends are planet friendly. Our responsible sourcing, ethical buying, and factory-direct styles were featured in the Boston Globe. We bring "Italian Warmth for all seasons" direct to you! ',
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:57:49.518Z",
    importedBy: "entity-db-cli",
  },
};
